'use client';

import { List } from '@phosphor-icons/react/dist/ssr';

import { Button } from '@skrym/shared/ui/button';
import { useSidebar } from '@skrym/shared/ui/sidebar';
import { cn } from '@skrym/shared/utils/cn';

interface SidebarOpenButtonProps
  extends Omit<React.HTMLProps<HTMLButtonElement>, 'color' | 'size' | 'children'> {}

export function SidebarOpenButton(props: SidebarOpenButtonProps) {
  const { className, ...rest } = props;

  const { setOpenMobile } = useSidebar();

  return (
    <Button
      {...rest}
      onClick={() => setOpenMobile(true)}
      type="button"
      icon
      variant="ghost"
      className={cn('w-8 h-8', className)}
    >
      <List weight="bold" className="w-5 h-5" />
    </Button>
  );
}
